import React from 'react';
import { Modal, Input, Form, Select, Table, Empty, Tabs, Button, Tag } from 'antd';
import dialog from "../../../common/utility/dialog";

const { Option } = Select;
const { TabPane } = Tabs;

class FormModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    handleCancel = () => {
        this.props.onClose();
        this.props.form.resetFields();
    }

    render() {

        const { getFieldDecorator } = this.props.form;
        getFieldDecorator('id', { initialValue: this.props.formValues.id });
        getFieldDecorator('isLista', { initialValue: this.props.formValues.isLista });

        return (
            <Modal
                title={"Configuración de Variante"}
                visible={this.props.visible}
                cancelText={"Cancelar"}
                okText={"Aceptar"}
                onCancel={this.handleCancel}
                onOk={this.props.onSave}
                style={{ top: 30 }}
            >
                <Form>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Form.Item label="Lista de Variantes">
                                {getFieldDecorator('idVariantes', {
                                    initialValue: this.props.formValues.idVariantes
                                })(
                                    <Select
                                        mode="multiple"
                                        placeholder={"Seleccione Variante"}
                                        optionFilterProp="children"
                                        onChange={(value) => this.props.onChangeForm(value, this.props.form)}
                                    >
                                        {this.props.formValues.atributos.map(item => (
                                            item.idTipoAtributo == 2 ?
                                                <Option key={item.id} value={item.id} codigo={item.abreviatura}>{item.nombre + "-" + item.descripcion}</Option>
                                                : null
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>

                        </div>


                        <div className="col-md-12 form-group">
                            <Tabs
                                tabBarExtraContent={
                                    <div className="custom-options">
                                        <Button
                                            icon="plus"
                                            type="primary"
                                            hidden
                                        >
                                            Agregar
                                        </Button>
                                    </div>
                                }
                            >
                                <TabPane tab="Opciones" key="1">
                                    <Table
                                        className={'table-referencia'}
                                        scroll={{ x: true }}
                                        size="small"
                                        style={{ overflowX: 'auto' }}
                                        pagination={false}
                                        dataSource={this.props.formValues.varianteItem}
                                        rowKey={record => record.id}
                                        rowSelection={{
                                            onChange: this.props.onChangeRow,
                                            selectedRowKeys: this.props.formValues.selectedRowKeys,
                                            hideDefaultSelections: false
                                        }}
                                        locale={{
                                            emptyText: <Empty
                                                image={Empty.PRESENTED_IMAGE_SIMPLE}
                                                description='Pulse el botón "+ Agregar".'
                                            />
                                        }}
                                        columns={[

                                            {
                                                title: 'Nombre',
                                                dataIndex: 'nombre',
                                                key: 'nombre',
                                                align: 'center',
                                                render: (value, row) => {
                                                    let color = row.idAtributo == this.props.formValues.idVariantes[0] ? '#2f54eb' : 'green';

                                                    return (
                                                        <Form.Item>
                                                            {getFieldDecorator(`arrNombre[${row.identifier}]`, {
                                                                initialValue: value,
                                                                rules: [{
                                                                    required: true,
                                                                    message: "Obligatorio"
                                                                }]
                                                            })(
                                                                <Input
                                                                    placeholder="Opcion"
                                                                    autoComplete="off"
                                                                    readOnly
                                                                    className="text-left"
                                                                    style={{ color: color }}
                                                                />
                                                            )}
                                                        </Form.Item>
                                                    );
                                                }
                                            },
                                            {
                                                title: 'Abreviatura',
                                                dataIndex: 'abreviatura',
                                                key: 'abreviatura',
                                                align: 'center',
                                                render: (value, row) => {
                                                    let color = row.idAtributo == this.props.formValues.idVariantes[0] ? 'geekblue' : 'green';

                                                    return (
                                                        <Tag color={color}>
                                                            {value}
                                                        </Tag>
                                                    );
                                                }
                                            },

                                        ]}
                                    />
                                </TabPane>
                            </Tabs>
                        </div>



                    </div>

                </Form>
            </Modal>
        );
    }
}
export default Form.create()(FormModal)